import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IExpenses } from '../../interfaces/expenses/iexpenses';
import { map } from 'rxjs';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { Filter } from '../../models/filter';
import { UnidadeService } from '../../services/unidade.service';
import { IUnidade } from '../../interfaces/unidade/iunidade';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'split-filter-unit',
  templateUrl: './split-filter-unit.component.html',
  styleUrls: ['./split-filter-unit.component.scss']
})
export class SplitFilterUnitComponent {
  public data: IFilterData[] = [];

  @Input() field!: string;
  @Input() label!: string;
  @Input() key!: string;
  @Input() groupId!: string;


  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  private filter = new Filter();

  constructor(private userService: UserService,
  
  ) {

  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    let userId = localStorage.getItem('userId');
    let filter = this.filter.convertFilterInQuery();
    this.userService.getbyID(Number(userId)).pipe(
      map((user: any) => user.units.filter((item: any) => item.isActive == true)),
      map((units: IUnidade[]) => units.map(units => ({ name: units.unitName, id: units.id as number } as IFilterData))),
    ).subscribe(
      (data: IFilterData[]) => {
        this.data = data;
      }
    )
  }

  onSearchDropdownChange($event: IFilter[]) {
    this.filter.setFilter($event[0].key as string, $event); 
    this.load();
  }


}
